import { DateTime } from 'luxon';

export const isDateToday = (date: string) => DateTime.now().hasSame(DateTime.fromISO(date), 'day');
